import React, { PureComponent } from 'react';
import { Button } from 'react-bootstrap';

import ModalResult from '../../facturotopia/ModalResult';

class ResponseResult extends PureComponent {
  handleOnAction = () => {
    this.props.onAction('success');
  };

  render() {
    const { title, result, btnText = 'Ok', extra, variant = 'modal', children } = this.props;

    return (
      <>
        {variant === 'modal' && (
          <ModalResult
            status="success"
            title={title}
            subtitle={result.message}
            extra={
              extra || (
                <Button
                  type="button"
                  onClick={this.handleOnAction}
                >
                  {btnText}
                </Button>
              )
            }
          >
            {!!children && children}
          </ModalResult>
        )}

        {variant !== 'modal' && (
          <>
            <div className="result mb-2">
              <div className="text-success">{result.message}</div>
            </div>
          </>
        )}
      </>
    );
  }
}

export default ResponseResult;
